/**
 * Aux-nav search popover — wires the toggle button to the popover shell
 * and routes the form submission to the correct destination based on which
 * scope radio is selected:
 *   - "website"    → native submit (?s=query on the current site, same tab)
 *   - "events"     → events.cals.org with today..Dec 31 of next year range (new tab)
 *   - "catalog"    → cals.bibliocommons.com (new tab)
 *   - "arstudies"  → arstudies.contentdm.oclc.org (new tab)
 */

import { initPopover } from "./popover.js";

const toggle = document.querySelector(".search-toggle");
const popover = document.getElementById("search-popover");

if (toggle && popover) {
  initPopover({
    popover,
    toggle,
    initialFocus: ".search-input",
  });

  const form = popover.querySelector(".search-form");
  const input = popover.querySelector(".search-input");
  const scopeRadios = popover.querySelectorAll('input[name="search-scope"]');

  const placeholderByScope = {
    website: "Search this website...",
    events: "Search events calendar...",
    catalog: "Search the catalog...",
    arstudies: "Search research portal...",
  };

  function syncPlaceholder() {
    if (!input) return;
    const scope = popover.querySelector(
      'input[name="search-scope"]:checked',
    )?.value;
    const next = placeholderByScope[scope];
    if (next) input.placeholder = next;
  }

  syncPlaceholder();
  scopeRadios.forEach((radio) => {
    radio.addEventListener("change", syncPlaceholder);
  });

  if (form && input) {
    form.addEventListener("submit", (e) => {
      const scope = popover.querySelector(
        'input[name="search-scope"]:checked',
      )?.value;
      const query = input.value.trim();
      if (!query) return; // let `required` attribute handle the empty case

      if (scope === "events") {
        e.preventDefault();
        const location = popover.querySelector(".search-filters")?.dataset.eventsLocation || "";
        window.open(buildEventsUrl(query, location), "_blank", "noopener,noreferrer");
      } else if (scope === "catalog") {
        e.preventDefault();
        window.open(buildCatalogUrl(query), "_blank", "noopener,noreferrer");
      } else if (scope === "arstudies") {
        e.preventDefault();
        window.open(buildArstudiesUrl(query), "_blank", "noopener,noreferrer");
      }
      // scope === "website" → fall through to native form submit
    });
  }
}

function buildEventsUrl(query, location) {
  const today = new Date();
  const start = formatDate(today);
  const end = `${today.getFullYear() + 1}-12-31`;
  const params = new URLSearchParams({ term: query });
  if (location) params.set("l", location);
  params.set("r", "range");
  params.set("start", start);
  params.set("end", end);
  return `https://events.cals.org/events?${params.toString()}`;
}

function buildCatalogUrl(query) {
  const params = new URLSearchParams({
    query,
    searchType: "smart",
  });
  return `https://cals.bibliocommons.com/v2/search?${params.toString()}`;
}

function buildArstudiesUrl(query) {
  return `https://arstudies.contentdm.oclc.org/digital/search/searchterm/${encodeURIComponent(query)}`;
}

function formatDate(d) {
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}
